import styles from '@features/artist/portfolio/components/PortfolioItemCard/PortfolioItemCard.module.css';
import { useClubConditionView } from '@features/work/view/club-full-profile/hooks/useClubConditionView.ts';
import { ChatBubbleOvalLeftIcon } from '@heroicons/react/24/solid';
import { Flex, Paper, Stack, Text } from '@mantine/core';
import { ExpandableText } from '@shared/helper/ExpandableComment.tsx';
import { translate } from '@shared/i18n/translate.tsx';
import { LBBackButton } from '@shared/modules';
import { ClubRating } from '@shared/utils/ClubRating.tsx';
import { useParams } from '@tanstack/react-router';
import dayjs from 'dayjs';
import { useIntl } from 'react-intl';

import { resolveImagePath } from '@/shared/helper';

// моковые отзывы

export const ClubReviewsSearch = () => {
  const { clubId } = useParams({
    from: '/artist/$id/profile-info/$clubId/reviews'
  });

  const intl = useIntl();

  const {
    state: { profileInfo }
  } = useClubConditionView({ clubId });

  const reviews = profileInfo.data?.data?.ratings ?? [];

  const filteredReviews = reviews.filter((review) => review?.comment);

  return (
    <Stack>
      <LBBackButton />
      <Text fw={600} size='lg'>
        Отзывы о клубе {profileInfo.data?.data?.clubInfo?.name}
      </Text>

      <ClubRating
        averageRating={profileInfo.data?.data?.ratingAverage?.totalAvg || 0}
        clubProfileId={Number(clubId)}
        mode='artist'
        ratingAverage={profileInfo.data?.data?.ratingAverage ?? null}
        variant='inline'
      />
      <br />

      {filteredReviews.length > 0 &&
        filteredReviews.map((review) => {
          const days = Math.ceil(
            (new Date(review.workEndDate).getTime() -
              new Date(review.workStartDate).getTime()) /
              (1000 * 60 * 60 * 24)
          );
          return (
            <Paper
              key={review?.clubRatingId}
              withBorder
              mb='md'
              p='lg'
              radius='md'
              shadow='sm'
            >
              {/* Верхний ряд: аватарка анонима и значок справа */}
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  marginBottom: '28px'
                }}
              >
                <div
                  style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
                >
                  {/* Аватар */}
                  {!review.isAnonymous ? (
                    <img
                      alt={`${review.artistFirstName}`}
                      src={resolveImagePath(review.avatarUrl)}
                      style={{
                        width: '50px',
                        height: '50px',
                        borderRadius: '50%',
                        objectFit: 'cover'
                      }}
                    />
                  ) : (
                    <div
                      style={{
                        width: '50px',
                        height: '50px',
                        borderRadius: '50%',
                        backgroundColor: 'lightskyblue',
                        color: 'white',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontWeight: 600,
                        fontSize: '14px'
                      }}
                    >
                      ?
                    </div>
                  )}

                  {/* Имя / Аноним и период работы */}
                  <div>
                    <Text c={review.isAnonymous ? 'black' : 'black'} fz={13}>
                      {review.isAnonymous
                        ? 'Anonim'
                        : `${review.artistFirstName}`}
                    </Text>

                    <Text c='dimmed' fz={12}>
                      {translate('commons.worked_for')}
                      {intl.formatMessage(
                        { id: 'commons.time.days' },
                        { count: days }
                      )}
                    </Text>
                  </div>
                </div>

                <div
                  style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
                >
                  <Text c='dimmed' fz={12}>
                    verified by
                  </Text>
                  <div
                    className={styles.spin}
                    style={{
                      backgroundImage: `url('/maskable_192.png')`,
                      borderRadius: '50%',
                      padding: '4px',
                      width: '30px',
                      height: '30px',
                      backgroundSize: 'cover',
                      backgroundPosition: 'center',
                      overflow: 'hidden'
                    }}
                  />
                </div>
              </div>

              <ExpandableText text={review?.comment} />

              <Text c='dimmed' fz='xs' mt='4px' style={{ textAlign: 'right' }}>
                {dayjs(review?.createdAt).format('DD.MM.YYYY')}
              </Text>

              {/* Reply if exists */}
              {review.reply && (
                <Paper
                  withBorder
                  mb='md'
                  p='sm'
                  radius='md'
                  style={{
                    backgroundColor: '#f5f5f5',
                    border: '1px solid #ccc'
                  }}
                >
                  <Flex align='center' gap={6} mb={4}>
                    <ChatBubbleOvalLeftIcon
                      style={{ width: 16, height: 16, color: '#444' }}
                    />
                    <Text c='dark' fw={500} fz='sm'>
                      {translate('commons.club_response')}
                    </Text>
                  </Flex>
                  <ExpandableText text={review?.reply} />
                </Paper>
              )}
            </Paper>
          );
        })}
    </Stack>
  );
};
